import { render, staticRenderFns } from "./SweetSpotInventoryMap.vue?vue&type=template&id=3c96170a&scoped=true"
import script from "./SweetSpotInventoryMap.vue?vue&type=script&lang=js"
export * from "./SweetSpotInventoryMap.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotInventoryMap.vue?vue&type=style&index=0&id=3c96170a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96170a",
  null
  
)

export default component.exports